//Chiamato in index.js con <ThemeProvider></ThemeProvider>

import { createMuiTheme } from '@material-ui/core/styles';


const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#764abc',
      light: '#a877ef',
      dark: '#441e8b',
    },
    secondary: {
      main: '#91A4AD',
      dark: '#63757e',
      light: '#eee',
    },
    text: {
      primary: '#000',
    },
  },
  background: {
    default: "#ffffff",
  }
});

export default theme;
